export enum CartInteraction {
    EDIT_IMPRINT = 'edit_imprint',
    PRODUCT_DETAILS = 'product_details',
    CONTINUE_SHOPPING = 'continue_shopping',
    EDIT_QUANTITY = 'edit_quantity',
    PROMO_CODE_EXPAND = 'promo_code_expand',
    CHANGE_PROMO_CODE = 'change_promo_code',
    PRICE_EXPAND = 'price_expand',
    ACCESSORY_EXPAND = 'accessory_expand',
    UPSELL_ADD = 'upsell_add',
    CART_REMOVE = 'cart_remove',
    UPSELL_REMOVE = 'upsell_remove',	
    VIEW_SIMILAR_PRODUCTS = 'view_similar_products'	
}